import React from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink,useLocation } from "react-router-dom";

function Footer() {
     const { pathname } = useLocation();
  return (
    <div>
      <footer>
        <div className="rgc-footer "></div>
        <div id="footers">
          {pathname === "/admin/dashboard" &&
          <div
            id="Rgc-Footer-Mobile"
            className="rgc-mobile-footer d-block d-lg-none"
          >
            <Row className="justify-content-center rgc-mobile-content p-3">
              <Col>
                <NavLink to="dashboard">
                  <i className="fas fa-home"></i>
                  <span>داشبورد</span>
                </NavLink>
              </Col>

              <Col>
                <NavLink to="profile">
                  <i className="fa fa-user"></i>
                  <span> پروفایل</span>
                </NavLink>
              </Col>
              

              <Col>
                <NavLink to="request">
                  <i className="fa fa-list"></i>
                  <span> درخواست ها</span>
                </NavLink>
              </Col>

              <Col>
                <NavLink to="follow/0">
                  <i className="fa fa-search"></i>
                  <span>پیگیری </span>
                </NavLink>
              </Col>
            </Row>
          </div>
          }
        </div>
      </footer>
    </div>
  );
}

export default Footer;
